<template>
  <div>
    <el-card shadow="never">
      <el-page-header @back="goBack" :content="componentName"> </el-page-header>
      <el-divider></el-divider>
      <!-- 订单信息 -->
      <div class="course_select_area">
        <div class="infor-title">订单信息：</div>
        <div>订单编号：{{ booking_info.booking_id }}</div>
        <div>套餐名称：{{ booking_info.course_name }}</div>
        <div>参加日期：{{ booking_info.trip_date }}</div>
        <div>
          签发服务商：{{ booking_info.operator }}({{
            booking_info.operator_id
          }})
        </div>
      </div>
      <!-- 学员信息 -->
      <div class="course_select_area">
        <div class="infor-title">报名信息：</div>
        <div>出行人ID：{{ trainee_id }}</div>
        <div>参加人姓名：{{ trainee_name }}</div>
        <div>出生日期：{{ trainee_birthday }}</div>
      </div>
      <!-- 证书 -->
      <div v-loading="loading" v-if="!is_certificate" class="certificate_group">
        <div id="certificate_div" ref="certificate">
          <!-- 背景图 -->
          <img
            class="certificate_img"
            src="~assets/img/certifigrate_model.jpg"
            alt=""
          />
          <!-- 服务商logo -->
          <img
            class="certificate_operator_logo"
            style="height: 120px; margin-right: 5px"
            :src="operator_logo"
            alt=""
          />
          <!-- 学员名称线 及学员姓名 -->
          <div class="certificate_name_line"></div>
          <div class="certificate_name">{{ trainee_name }}</div>
          <!-- 教练签名 及认证教练，签发日期 -->
          <div
            v-show="!coach_signature == ''"
            class="certificate_coach_line"
          ></div>
          <div
            v-show="!coach_checked == ''"
            class="certificate_coach_line"
          ></div>
          <div class="certificate_coach_sign">
            <img style="height: 100%" :src="coach_signature" alt="" />
          </div>
          <div v-show="coach_signature == ''" class="coach_name">
            {{ coach_checked }}
          </div>
          <div class="certificate_sign_date">
            签发日期:{{ booking_info.trip_date }}
          </div>

          <!-- 考核内容 -->
          <div class="certificate_course">
            <div>
              课程内容:
              <span
                class="style-section-content"
                v-for="item in course_content_list"
                :key="item.section_id"
                >{{ item.section_name }}
              </span>
            </div>
            <div>
              课程时长:
              <span class="style-section-content">
                {{ trainingTime }} 分钟</span
              >
            </div>
            <div v-show="!coachComment == ''">
              教练评价:
              <span class="style-section-content"> {{ coachComment }}</span>
            </div>
          </div>

          <!-- 二维码指向 注册链接 -->
          <div class="certificate_qr_code">
            <vue-qr
              :margin="15"
              colorDark="#0f6ea3"
              colorLight="#FFF"
              :logoSrc="qrImageUrl"
              :text="qrCode"
              :size="150"
            ></vue-qr>
            <div>
              <!-- <div>No.:{{ certifitate_no }}</div> -->
              <div class="certificate_qr_infor">扫码记录本次冲浪</div>
            </div>
          </div>
          <!-- 认证编号 -->

          <!-- 星球玩家俱乐部 -->
          <div class="certificate_logo">
            <div style="display: inline-block; font-size: 1rem">认证机构：</div>

            <div
              style="display: inline-block; margin-right: 20px; font-size: 1rem"
            >
              <img
                style="
                  height: 20px;
                  margin-right: 5px;
                  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
                "
                :src="operator_avatar"
                alt=""
              />
              {{ booking_info.operator }}
            </div>
            <div
              style="display: inline-block; margin-right: 10px; font-size: 1rem"
            >
              <img
                style="height: 20px; margin-right: 5px"
                src="~assets/img/TRAVER-logo.jpg"
                alt=""
              />
              星球玩家俱乐部
            </div>
          </div>
        </div>
      </div>
      <!-- 已生成认证后的图片 及下载按钮 -->
      <div v-else>
        <!-- 图片 -->
        <img
          class="certificate_img"
          :src="certificate_Url"
          alt="暂未生成证书"
        />
      </div>
      <!-- 操作区 -->
      <div class="operation-area-style">
        <el-button
          @click="makeCertButton"
          v-show="!this.is_certificate && !this.reMakeCertiButton"
          >生成认证</el-button
        >
        <el-button-group>
          <el-button type="primary" plain size="mini" v-show="is_certificate">
            下载
          </el-button>
          <el-button type="primary" plain size="mini" v-show="is_certificate">
            发送
          </el-button>
          <el-button
            size="mini"
            type="primary"
            plain
            v-show="is_certificate"
            @click="showReMakeCert"
          >
            重新生成
          </el-button>
          <el-button
            @click="reMakeCertButton"
            size="mini"
            v-show="reMakeCertiButton"
            type="success"
          >
            确认重新生成
          </el-button>
          <el-button
            @click="backCert"
            size="mini"
            v-show="reMakeCertiButton"
            type="success"
          >
            返回
          </el-button>
        </el-button-group>
        <!-- 重新生成：将url清空，将is_certification改为false 。确认删除原来的记录，-->
      </div>

      <!-- 证书信息编辑 -->
      <div v-show="!is_certificate" class="course_select_area">
        <div class="infor-title">课程信息：</div>
        <!-- 选择课程 -->

        <div class="infor-item">
          <span class="demonstration"
            >选择课程内容：
            <span v-for="item in course_content_list" :key="item.section_id">
            </span>
            <link-button
              @clickLinkButton="clickToCourse"
              buttonName="添加/调整课程"
            ></link-button>
          </span>
          <select-area
            @checkALl="checkAll"
            @checkCourse="checkCourse"
            :data="course_list"
          ></select-area>
        </div>
        <div class="infor-item">
          <span> 添加课程时长：</span>
          <input-time
            @timeChange="timeChange"
            :select_time="trainingTime"
          ></input-time>
        </div>
        <div class="infor-item">
          <span> 选择教练签名：</span>
          <el-autocomplete
            size="mini"
            v-model="coach_checked"
            :fetch-suggestions="querySearchCoach"
            placeholder="请输入内容"
            @select="handleSelectCoach"
          ></el-autocomplete>
          <link-button
            @clickLinkButton="clickToCoach"
            buttonName="添加教练"
          ></link-button>
        </div>
        <div>
          <span>添加教练评价：</span>

          <el-input
            style="width: 20%"
            type="textarea"
            placeholder="请输入内容"
            v-model="coachComment"
            maxlength="30"
            show-word-limit
          >
          </el-input>
        </div>
      </div>

      <!-- <el-button @click="qCodeButton">生成二维码</el-button> -->
    </el-card>
  </div>
</template>

<script>
import InputTime from "../../components/common/input/TimeInputSecond";
//  冲浪的时间选择器组件
import html2canvas from "html2canvas";
import vueQr from "vue-qr";
import * as qiniu from "qiniu-js";
// import SelectArea from "../../components/common/select/SelectAreaCheck";
import SelectArea from "../../components/common/select/SelectAreaDiv";
import { tpx_app } from "../../network/request";
import { Base64 } from "js-base64";
import LinkButton from "../../components/common/button/LinkButton";
export default {
  components: {
    "input-time": InputTime,
    "select-area": SelectArea,
    LinkButton,
    vueQr,
  },
  name: "certificate",
  data() {
    return {
      log_id: "", // 保存记录成功后，返回冲浪记录的ID

      loading: false,
      componentName: "证书认证",
      reMakeCertiButton: false, // 重新生成确认
      is_certificate: false, // 是否已认证
      qrCodeLink:
        "https://192.168.50.243:8081/#/pages/surfcourse/certificateintroduce", // 引导链接 或 主页
      qrCode: "", // 二维码内容cid
      upload_token: "", // 七牛 upload token
      booking_info: {},
      operator_logo: "",
      operator_avatar: "",
      trainee_name: "", // 认证学员姓名
      trainee_birthday: "",
      trainee_id: 1, // 出行人ID
      options_course: [],
      props_course: {},
      certificate_Url: "", // 生成的证书图片李娜将
      member_id: null, // 会员ID
      // 教练
      coach_checked: null, // 选择的教练名称
      coach_checked_obj: {},
      coach_signature: "", // 选择的教练签字
      coach: {}, // 教练信息
      coachComment: "", // 教练评价
      // 课程
      course_list: [],
      coach_list: [], // 根据服务商获取的教练列表
      course_content: "",
      course_content_list: [], // 课程内容列表
      trainingTime: null, // 课程时间
      qrImageUrl: require("../../assets/img/TRAVER-logo.jpg"), // 二维码
    };
  },

  mounted() {
    // 获取引导页链接
    this.$http.get("/get_guide_pages").then((res) => {
      if (res.data.errno == "0") {
        this.qrCodeLink =
          res.data.address + "/#/pages/surfcourse/certificateintroduce";
      }
    });
    this.booking_info = this.$route.params.booking_info;
    this.operator_logo = this.$route.params.booking_info.operator_logo;
    this.operator_avatar = this.$route.params.booking_info.operator_avatar;
    this.trainee_id = this.$route.params.item.trainee_id;
    this.log_id = this.$route.params.item.log_id;
    this.certificate_Url = this.$route.params.item.certificate_Url;
    this.is_certificate = this.$route.params.item.is_certificate;
    this.trainee_name = this.$route.params.item.trainee_name;
    this.trainee_birthday = this.$route.params.item.birthday;
    this.trainee_id = this.$route.params.item.trainee_id;

    // 获取课程信息
    tpx_app({
      url: "get_course_all_section",
      params: {
        course_id: 1,
      },
    }).then((res) => {
      const { errno, errmsg, data } = res.data;
      // data.course.forEach((item) => {
      //   item.checked_data_list = [];
      // });
      this.course_list = data.section;
    });
    // 获取教练列表
    tpx_app({
      url: "/get_course_coach",
      params: {
        operator_id: this.$route.params.booking_info.operator_id,
      },
    }).then((res) => {
      const { errno, data } = res.data;
      data.forEach((item) => {
        let i = {
          coach_id: item.coach_id,
          value: item.coach_name,
        };
        this.coach_list.push(i);
      });
    });
    // --------------
    //  获取 七牛 uploadtoken
    tpx_app({
      url: "get_qiniu_upload_token",
    }).then((res) => {
      this.upload_token = res.data.token;
    });
    // 检查是否携带数据
    if (this.$route.params.booking_info) {
      // 获取证书图片
      this.$route.params.booking_info.traveller.forEach((i) => {
        if (i.trainee_id == this.$route.params.trainee_id) {
          this.is_certificate = i.is_certificate;
          this.certificate_Url = i.certificate_Url;
        }
      });
    } else {
      this.$router.push({ name: "certificate" });
    }
  },
  watch: {},
  methods: {
    // 重新生成
    showReMakeCert() {
      this.is_certificate = false;
      this.reMakeCertiButton = true;
    },
    // 返回
    backCert() {
      this.is_certificate = true;
      this.reMakeCertiButton = false;
    },
    // 确认重新生成
    reMakeCertButton() {
      // 删除已有的记录( 1.删除图片 2.删除记录 )
      this.$http.get(`/delete_course_log?log_id=${this.log_id}`).then((res) => {
        if (res.data.errno == "0") {
          // 重新生成
          // 让证书名 和之前的不一样
          this.makeCertButton();
          this.reMakeCertiButton = false;
        }
      });
    },
    // 生成证书
    // 1.发送请求生成记录，数据库生成记录。2.返回二维码信息，介绍链接和 ymncode，以及cid 和booking，用于验证。
    //3.截图：生成图片-》转为base64 -》 去掉base头部 -》计算base64大小 -》 请求上传七牛 -》返回链接 -》更新记录
    // 4。返回图片链接，更新视图
    makeCertButton() {
      this.loading = true;
      // prominse 上传记录
      // 返回id生成二维码
      // 节id 列表
      if (this.coach_checked_obj.coach_id == "") {
      }
      let section_id_list = [];
      this.course_content_list.forEach((item) => {
        section_id_list.push(item.section_id);
      });
      let logOfCourse = {
        member_id: this.member_id,
        operator_id: this.booking_info.operator_id,
        course_id: 1,
        section_id_list: section_id_list,
        booking_id: this.booking_info.booking_id,
        training_Time: this.trainingTime,
        coach_id: this.coach_checked_obj.coach_id,
        coach_comment: this.coachComment,
        trainee_name: this.trainee_name,
        join_date: this.booking_info.trip_date,
      };
      console.log(logOfCourse);
      tpx_app({
        url: "/add_course_log",
        method: "POST",
        data: logOfCourse,
      }).then((res) => {
        const { errno, errmsg } = res.data;
        if (errno == "0") {
          this.log_id = res.data.log_id;
          // 组成qrcode的数据
          // let qrCodeData = {
          //   y_code: res.data.y_code,
          //   m_code: res.data.m_code,
          //   n_code: res.data.n_code,
          //   booking_id: this.booking_info.booking_id,
          //   cid: res.data.cid,
          // };
          let y_code = res.data.y_code;
          let m_code = res.data.m_code;
          let n_code = res.data.n_code;
          let booking_id = this.booking_info.booking_id;
          let cid = res.data.cid;
          let op = res.data.op;
          // 转字符串
          // this.qrCode = JSON.stringify(qrCodeData);

          this.qrCode =
            this.qrCodeLink +
            "?y_code=" +
            y_code +
            "&m_code=" +
            m_code +
            "&n_code=" +
            n_code +
            "&booking_id=" +
            booking_id +
            "&cid=" +
            cid +
            "&op=" +
            op;
          setTimeout(() => this.shotImageButton(), 500);
        } else {
          this.loading = false;
          this.$notify({ title: "注意", message: errmsg, type: "warning" });
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    // 自动匹配教练
    querySearchCoach(queryString, cb) {
      var coach_list = this.coach_list;
      var results = queryString
        ? coach_list.filter(this.createFilter(queryString))
        : coach_list;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (res) => {
        return res.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    //  选择教练时
    handleSelectCoach(value) {
      tpx_app({
        url: "get_course_coach",
        params: {
          coach_id: value.coach_id,
        },
      }).then((res) => {
        const { errno, errmsg, data } = res.data;
        // console.log(data);

        if (data.coach_signature) {
          this.coach_signature = data.coach_signature;
        } else {
          this.coach_name = data.coach_name;
          this.coach_signature = "";
        }
        this.coach_checked_obj = value;
      });
    },
    // 截图
    shotImageButton() {
      let options = {
        allowTaint: false,
        backgroudColor: null,
        useCORS: true,
        height: document.getElementById("certificate_div").offsetHeight, // 下面解决当页面滚动之后生成图片出现白边问题
        width: document.getElementById("certificate_div").offsetWidth,
        windowWidth: document.body.scrollWidth,
        windowHeight: document.body.scrollHeight,
        scrollX: 0,
        scrollY: -window.pageYOffset,
        // x: 0,
        // y: 0,
        scale: 4, //
      };
      //
      // document.getElementById("certificate_div")
      html2canvas(this.$refs.certificate, options).then((canvas) => {
        let image = canvas.toDataURL("image/png");
        // 去掉base64头，【需要压缩一下图片再上传，先图片4M太大了】
        let data_image = image.split(";base64,")[1];
        // 上传到七牛
        this.upLoadQiNiu(data_image);
        // this.dataURL = dataURL;
        // 创建一个a标签
        // let link = document.createElement("a");
        // link.href = canvas.toDataURL(); //下载链接
        // let operator = this.booking_info.operator;
        // link.setAttribute("download", "lession" + operator + ".png");
        // link.style.display = "none"; //a标签隐藏
        // document.body.appendChild(link);
        // link.click();
      });
    },
    // 转换成json
    strToJson(str) {
      var json = eval("(" + str + ")");
      return json;
    },
    // 上传至七牛云
    upLoadQiNiu(data_image) {
      // 计算字符大小
      let fileSize = this.fileSize(data_image);
      let that = this;
      let key =
        "cert" + this.log_id + "booking_id" + this.booking_info.booking_id;
      let encodeKey = Base64.encode(key);
      let url =
        "/putb64/" + fileSize + "/key/" + encodeKey;
      // 上传图片
      let xhr = new XMLHttpRequest();
      // 链接为：
      // console.log(url);
      // ajax
      xhr.open("POST", url, true);
      xhr.setRequestHeader("Content-Type", "application/octet-stream");
      xhr.setRequestHeader("Authorization", `UpToken ${this.upload_token}`);
      xhr.send(data_image);
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          // xhr.readyState == 4: 响应数据已经完成 状态码
          if (xhr.status == 200) {
            var keyText = xhr.responseText;
            /*返回的key是字符串，需要装换成json*/
            keyText = that.strToJson(keyText);

            /* 七牛云空间网址，keyText.key 是返回的图片文件名*/
            var certificate_Url = "http://szsxtravel.top/" + keyText.key;
            // alert(certificate_Url);
            that.certificate_Url = certificate_Url;
            that.reNewCertificateLog();
          } else {
            // 删除记录
            that.$http
              .get(`/delete_course_log?log_id=${that.log_id}`)
              .then((res) => {
                if (res.data.errno == "0") {
                  // 返回警告
                  that.$notify({
                    title: "警告",
                    message: "生成证书出错（err:qiniu），请重试",
                    type: "warning",
                  });
                  // 改 loading 状态
                  this.loading = false;
                }
              });
          }
        }
      };
    },
    checkAll(value) {
      this.course_content_list = value;
    },
    checkCourse(value) {
      this.course_content_list = value;
    },
    timeChange(value) {
      this.trainingTime = value;
      // console.log("时间" + this.trainingTime);
    },
    // 通过base64编码字符流计算文件流大小函数
    fileSize(str) {
      var fileSize;
      // 找到等号，把等号也去掉
      if (str.indexOf("=") > 0) {
        var indexOf = str.indexOf("=");
        str = str.substring(0, indexOf); // 把末尾的’=‘号去掉
      }
      fileSize = parseInt(str.length - (str.length / 8) * 2);
      return fileSize;
    },
    // 更新记录
    reNewCertificateLog() {
      // 开始
      tpx_app({
        url: "renew_course_log",
        params: {
          log_id: this.log_id,
          certificate_Url: this.certificate_Url,
        },
      }).then((res) => {
        if (res.data.errno == "0") {
          this.is_certificate = true;
          this.loading = false;
          this.$notify({
            title: "成功",
            message: res.data.errmsg,
            type: "success",
          });
        } else {
          this.$notify.error({
            title: "错误",
            message: res.data.errmsg,
          });
        }
      });
      // 结束
    },
    clickToCourse() {
      let newpage = this.$router.resolve({
        path: "/course_creat_section",
        params: {
          course_id: 1,
        },
      });
      window.open(newpage.href, "_blank");
    },
    clickToCoach() {
      let newpage = this.$router.resolve({
        name: "course",
        query: {
          tabname: "third",
        },
      });
      window.open(newpage.href, "_blank");
    },
    // base64 转 file
    // dataURLtoFile(dataurl) {
    //   var arr = dataurl.split(","),
    //     mime = arr[0].match(/:(.*?);/)[1],
    //     bstr = atob(arr[1]),
    //     n = bstr.length,
    //     u8arr = new Uint8Array(n);
    //   while (n--) {
    //     u8arr[n] = bstr.charCodeAt(n);
    //   }
    //   return new Blob([u8arr], { type: mime });
    // },
  },
};
</script>

<style>
.style-section-content {
  font-weight: 500;
  color: #e2b27e;
}
.certificate_group {
  position: relative;
  margin-bottom: 20px;
  /* background-color: bisque; */
  /* text-align: center; */
}
/* 证书div */
/* .certificate_div {
  width: 100%;
  display: inline-block;
} */
/* 证书图片 */
.certificate_img {
  display: inline-block;
  height: 100%;
  width: 100%;
}

/* 获得认证的姓名 */
.certificate_name {
  position: absolute;
  font-size: 2rem;
  color: black;
  width: 30%;
  top: 80%;
  left: 18%;
}
/* 服务商logo */
.certificate_operator_logo {
  position: absolute;
  font-size: 2rem;
  color: black;
  /* width: 30%; */
  top: 18%;
  left: 80%;
}

/* 教练 文字姓名 */
.coach_name {
  position: absolute;
  font-size: 2rem;
  color: black;
  width: 80%;
  top: 80%;
  left: 45%;
}
/* 姓名底线 */
.certificate_name_line {
  position: absolute;
  color: lightgray;
  border-bottom: 0.1rem solid;
  width: 20%;
  top: 87%;
  left: 13%;
}
/* 会员名 */

/* 签发日期 */
.certificate_sign_date {
  position: absolute;
  color: rgb(102, 99, 99);
  font-size: 0.1rem;

  width: 20%;
  top: 88%;
  left: 17%;
}

/* 教练底线 */
.certificate_coach_line {
  position: absolute;
  color: lightgray;
  border-bottom: 0.1rem solid;
  width: 20%;
  top: 87%;
  left: 40%;
}

/* --------认证课程内容---------- */
.certificate_course {
  position: absolute;
  color: #c49a6c;
  width: 45%;
  top: 45%;
  left: 30%;
  /* 字体样式 */
  font-family: arial, sans-serif;
  font-size: 1.4rem;
  font-weight: 900;
  letter-spacing: 0.4pt;
  word-spacing: -0.2pt;
}

/* 教练签名 */
.certificate_coach_sign {
  position: absolute;
  color: black;
  font: 1rem;
  height: 40%;
  top: 65%;
  left: 38%;
}

/* 认证编号 */
.certificate_certificate_num {
  position: absolute;
  color: black;
  font: 1rem;
  width: 10%;
  top: 65%;
  left: 50%;
}

/* 二维码 */
.certificate_qr_code {
  text-align: center;
  position: absolute;
  color: #0f6ea3;
  font-weight: bolder;
  font: 1rem;
  width: 80%;
  top: 45%;
  left: -23%;
}

/* 右下角落款 */
.certificate_logo {
  position: absolute;
  text-shadow: 1px 1px 0px rgb(255, 255, 255);
  font-weight: 900;
  color: #c49a6c;
  width: auto;
  top: 94%;
  left: 45%;
}

/* 信息区域 */
.course_select_area {
  background-color: wheat;
  padding: 20px;
  border-radius: 5px;
  margin-bottom: 20px;
}
.infor-title {
  font-size: 1rem;
  border-left: 5px solid #ff5420;
  padding: 0 5px;
  margin-bottom: 20px;
}

.infor-item {
  margin-bottom: 10px;
}
.select-area-certificate {
  background-color: whitesmoke;
  padding: 10px;
}
.certificate_qr_infor {
  position: absolute;
  padding: 3px;
  width: 18.2%;
  background-color: #0f6ea3;
  /* border-radius: 10px; */
  color: white;
  float: right;
  left: 40.6%;
}
.operation-area-style {
  margin: 10px 0;
  padding: 10px;
  border-radius: 5px;
  background-color: wheat;
  text-align: center;
}
</style>